/* shopping areas */
export const GET_SHOPPING_AREAS = "GET_SHOPPING_AREAS"
export const GET_SHOPPING_AREAS_SUCCESS = "GET_SHOPPING_AREAS_SUCCESS"
export const API_ERROR = "API_ERROR"

export const GET_SHOPPING_AREAS_V2 = "GET_SHOPPING_AREAS_V2"
export const GET_SHOPPING_AREAS_V2_SUCCESS = "GET_SHOPPING_AREAS_V2_SUCCESS"
export const GET_SHOPPING_AREAS_V2_ERROR = "GET_SHOPPING_AREAS_V2_ERROR"
